import { useEffect, useState } from "react";
import { supabase } from "../../lib/supabase";

export default function MulheresAdmin() {
  const [mulheres, setMulheres] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchMulheres();
  }, []);

  const fetchMulheres = async () => {
    setLoading(true);
    setError(null);
    try {
      const { data, error: queryError } = await supabase
        .from("mulheres")
        .select("*")
        .order("created_at", { ascending: false });

      if (queryError) {
        console.error("Erro ao buscar mulheres:", queryError);
        setError(queryError.message);
        setMulheres([]);
      } else {
        setMulheres(data || []);
      }
    } catch (err) {
      console.error("Erro inesperado:", err);
      setError("Erro ao carregar dados");
      setMulheres([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h1 style={{ fontSize: "1.5rem", fontWeight: "700", marginBottom: "1.5rem" }}>
        Mulheres Cadastradas
      </h1>

      {loading ? (
        <p>Carregando...</p>
      ) : error ? (
        <p style={{ color: "#dc2626" }}>Erro: {error}</p>
      ) : mulheres.length === 0 ? (
        <p style={{ color: "#6b7280" }}>Nenhuma mulher cadastrada.</p>
      ) : (
        <div style={{ 
          backgroundColor: "#fff", 
          borderRadius: "8px", 
          overflow: "hidden",
          boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
        }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ backgroundColor: "#f9fafb" }}>
                <th style={{ padding: "0.75rem 1rem", textAlign: "left", fontSize: "0.875rem", fontWeight: "600" }}>Nome</th>
                <th style={{ padding: "0.75rem 1rem", textAlign: "left", fontSize: "0.875rem", fontWeight: "600" }}>Email</th>
                <th style={{ padding: "0.75rem 1rem", textAlign: "left", fontSize: "0.875rem", fontWeight: "600" }}>Cidade</th>
                <th style={{ padding: "0.75rem 1rem", textAlign: "left", fontSize: "0.875rem", fontWeight: "600" }}>Cadastro</th>
              </tr>
            </thead>
            <tbody>
              {mulheres.map((mulher, index) => (
                <tr key={mulher.id} style={{ borderTop: index > 0 ? "1px solid #e5e7eb" : "none" }}>
                  <td style={{ padding: "0.75rem 1rem", fontSize: "0.875rem" }}>{mulher.nome}</td>
                  <td style={{ padding: "0.75rem 1rem", fontSize: "0.875rem", color: "#6b7280" }}>{mulher.email}</td>
                  <td style={{ padding: "0.75rem 1rem", fontSize: "0.875rem", color: "#6b7280" }}>
                    {mulher.cidade}, {mulher.estado}
                  </td>
                  <td style={{ padding: "0.75rem 1rem", fontSize: "0.875rem", color: "#6b7280" }}>
                    {new Date(mulher.created_at).toLocaleDateString("pt-BR")}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
